import axios from 'axios'
import { getCall, getCommonParams, postCall, putCall } from '../../utils/apiCalls'
import { BaseCoreURL, BaseURL } from '../../config'
import moment from 'moment'

import {
  OPERATOR_DEALS_LIST,
  DEAL_DATA,
  AUDIT_DEAL_DATA,
  OPERATOR_ROUTES_LIST,
  ROUTE_SERVICES,
  CLEAR_DEAL_DATA,
  FULL_OPERATOR_ROUTES_LIST,
  SERVICE_SEATLAYOUT,
  THROW_SEATMAP_ERROR,
  ALL_ROUTES_INFO,
  OPERATOR_DEALS_LIST_LOADING,
  GET_DEAL_DATA,
  GET_SERVICE_LIST,
  GET_SEAT,
  GET_BENCH_MARK,
  CLEAR_BENCH_MARK,
  GET_TOP_ROUTES,
  GET_AGGREGATE_DATA,
  GET_DEALS_SUMMARY,
  GET_DATE_WISE_AGGREGRATE_DATA,
  SET_DYNAMIC_SEAT_DATA,
  ADD_BTN_CLICKED
} from './actionTypes'

import {
  GET_SETLAYOUT,
  GET_DEALS_LIST,
  GET_DEAL_AUDIT_LIST,
  UPDATE_DEALS_STATUS,
  // GET_OPERATOR_ROUTES,
  GET_ROUTE_SERVICES,
  GET_OPERATOR_SERVICES,
  GET_PAYTM_CITIES,
  PHONETIC_CITY_SEARCH,
  GET_SERVICE_SEATLAYOUT,
  GET_ALL_ROUTES_INFO,
  REFRESH_DEAL,
  FETCH_DEAL_LIST,
  BENCCH_MARKING_DATA,
  FETCH_TOP_ROUTES,
  GET_FETCH_DATA,
  FETCH_AGGREGATE_DATA,
  FETCH_DEALS_SUMMARY,
  FETCH_DATE_WISE_AGGREGATE,
} from '../../config/urls';
import { opdbGTM } from '../../utils/pulseUtils'

export const getOperatorDealsList = (merchantId, isNewQuery) => dispatch => {
  dispatch({
    type: OPERATOR_DEALS_LIST_LOADING,
    payload: { data: true },
  })
  getCall(GET_DEALS_LIST, {}, ['merchant'])
    .then(res => {
      if (res && res.status === 200) {
        // in case of no data, skip the dispatch
        if (!res.data || !res.data.length) {
          dispatch({
            type: OPERATOR_DEALS_LIST_LOADING,
            payload: { data: false },
          })
          return
        };

        dispatch({
          type: OPERATOR_DEALS_LIST,
          payload: { data: res.data || [] },
        })
        dispatch({
          type: OPERATOR_DEALS_LIST_LOADING,
          payload: { data: false },
        })
      } else {
        dispatch({
          type: OPERATOR_DEALS_LIST_LOADING,
          payload: { data: false },
        })
        alert(((res.response || {}).data || {}).message || 'Error Occurred, please try later.');
      }
    })
}

function getServiceDate(serviceDate) {
  return moment(serviceDate).format("YYYY-MM-DD");
}

export const fetchSeatLayout = (serviceData, metaDetails) => dispatch => {
  // const url = BaseURL + GET_SERVICE_SEATLAYOUT;
  // const serviceDate = getServiceDate(serviceData.departure_datetime); 
  // const trip_id = serviceData.trip_id;
  const data = {
    paytm_src_id: metaDetails.paytm_src_id,
    paytm_dest_id: metaDetails.paytm_dest_id,
    route_id: serviceData.route,
    service_id: serviceData.id,
    // Adding essesntailParams
    __essentialParams__: ['merchant']
    // "provider_id": serviceData.provider_id,
    // "provider_name": serviceData.provider_name,
    // "trip_id": trip_id,
    // "journey_date": serviceDate,
    // "is_return_trip": "false",
    // "is_single_lady": serviceData.single_lady_feature+"",
    // "boarding_point_id": serviceData.boarding_points[0].id,
    // "dropping_point_id": serviceData.dropping_points[0].id,
    // "user_ip": null,
    // "raw_fares": serviceData.raw_fares,
    // "fare": serviceData.info.fare,
    // "bus_type_name": serviceData.info.busType,
    // "bus_type_code": serviceData.bus_type_code || null,
    // "route_id": serviceData.route_id,
    // "source_id": serviceData.info.sourceStationId,
    // "destination_id": serviceData.info.destinationStationId,
    // "service_id": serviceData.service_id,
    // "service_code": serviceData.service_id,
    // "service_category_id": null,
    // "class_id": null,
    // "departure_datetime": serviceData.departure_datetime,
    // "operator_id": serviceData.operator_id,
    // "concession": null
  }
  postCall(GET_SETLAYOUT, data)
    .then(res => {
      if (res && res.data && res.data.status_code === 200) {
        dispatch({
          type: SERVICE_SEATLAYOUT,
          payload: { data: res.data, metaDetails: serviceData || [] },
        });
      } else {
        let err = (res && res.response && res.response.data) ? res.response.data.message : "Unknown error";
        dispatch({
          type: THROW_SEATMAP_ERROR,
          payload: { data: err || "", metaDetails: serviceData || [] },
        });
      }
    });
}

export const updateDealStatus = (data, merchant, callback) => dispatch => {
  postCall(UPDATE_DEALS_STATUS, { ...data, __essentialParams__: ['merchant'] })
    .then(res => {
      if (res && res.status === 200) {
        callback();
        alert('Deal Updated Successfully.')
        // dispatch({
        //   type: UPDATE_DEAL_SUCCESS,
        //   // payload: res.data,
        // })
      } else {
        const cityList = res && res.response && res.response.data && res.response.data.body;
        const errMsg = (res.response.data || {}).message;
        const maxCitiesToShow = 3;
        alert(errMsg); 

        const displayedCities = cityList && cityList.data && cityList.data.length > 0
        ? cityList.data.length > maxCitiesToShow
          ? cityList.data.slice(0, maxCitiesToShow).join(', ') + `, +${cityList.data.length - maxCitiesToShow}`
          : cityList.data.join(', ')
        : '';
        const shouldShowDisplayCities = displayedCities && displayedCities.length > 0;
        const err = `${errMsg} ${shouldShowDisplayCities && displayedCities}`;
        if(err) alert(err); 
      }
    })
}

export const getOperatorRoutes = () => dispatch => {
  getCall(GET_PAYTM_CITIES/*GET_OPERATOR_ROUTES*/, {}, ['merchant'])
    .then(res => {
      if (!res.data || !res.data.length) return;
      dispatch({
        type: FULL_OPERATOR_ROUTES_LIST,
        payload: { data: res.data || [] },
      })
    })
}

export const createDeal = (data, merchant, callback) => dispatch => {
  postCall(GET_DEALS_LIST, { ...data, __essentialParams__: ['merchant'] })
    .then(res => {
      if (res && res.status === 200) {
        alert('Deal Created Successfully.');
        callback();
      }
      else {
        const cityList = res && res.response && res.response.data && res.response.data.body;
        const errMsg = (res.response.data || {}).message || 'something went wrong please try again';
        const maxCitiesToShow = 3;

        const displayedCities = cityList && cityList.data && cityList.data.length > 0
        ? cityList.data.length > maxCitiesToShow
          ? cityList.data.slice(0, maxCitiesToShow).join(', ') + `, +${cityList.data.length - maxCitiesToShow}`
          : cityList.data.join(', ')
        : '';
        const shouldShowDisplayCities = displayedCities && displayedCities.length > 0;
        let err = `${errMsg} ${shouldShowDisplayCities && displayedCities}`;
        if(err ===  "[object Object] " && errMsg.status === "500") {
          err = 'something went wrong please try again';
        }
        alert(err);
      }
    })
}

export const updateDeal = (data, callback) => dispatch => {
  putCall(GET_DEALS_LIST, { ...data, __essentialParams__: ['merchant'] })
    .then(res => {
      if (res && res.status === 200) {
        alert('Deal Updated Successfully.');
        callback();
      }
      else {
        const cityList = res && res.response && res.response.data && res.response.data.body;
        const errMsg = (res.response.data || {}).message;
        const maxCitiesToShow = 3;

        const displayedCities = cityList && cityList.data && cityList.data.length > 0
        ? cityList.data.length > maxCitiesToShow
          ? cityList.data.slice(0, maxCitiesToShow).join(', ') + `, +${cityList.data.length - maxCitiesToShow}`
          : cityList.data.join(', ')
        : '';
        const shouldShowDisplayCities = displayedCities && displayedCities.length > 0;
        const err = `${errMsg} ${shouldShowDisplayCities && displayedCities}`;
        alert(err);
      }
    })
}

export const fetchDealData = (dealId, isEditCase) => dispatch => {
  getCall(GET_DEALS_LIST + '/' + dealId, {}, ['merchant'])
    .then(res => {
      if (res && res.status === 200) {
        dispatch({
          type: DEAL_DATA,
          payload: { data: res.data || [] },
        })
        // in case of custom deal and all routes, do not fetch the services
        if (res.data.paytm_route !== '*-*' && !isEditCase) {
          let ids = (res.data.paytm_route || '-').split('-');
          const merchantId = localStorage.getItem('merchant-id');
          fetchServices({ paytm_src_id: ids[0], paytm_dest_id: ids[1], is_round_trip: false }, merchantId)(dispatch);
        }
      } else {
        alert('Error, Please try again.');
      }
    })
}

export const fetchAuditDealData = (providerid, operatorid, date) => dispatch => {
  getCall(`${GET_DEAL_AUDIT_LIST}?provider_id=${providerid}&operator_id=${operatorid}&current_date=${date}&duration=45`, {}, ['merchant'])
    .then(res => {
      if (res && res.status === 200) {
        dispatch({
          type: AUDIT_DEAL_DATA,
          payload: { data: res.data || [] },
        })
      } else {
        alert('Error, Please try again.');
      }
    })
}

export const fetchServices = (data, merchant = null, addReturnTripDeal = () => {}, isReverseRouteClicked) => dispatch => {
  // postCall(GET_OPERATOR_SERVICES/*GET_ROUTE_SERVICES*/, data)
  postCall(GET_OPERATOR_SERVICES/*GET_ROUTE_SERVICES*/, { ...data, __essentialParams__: ['merchant'] })
    .then(res => {
      let isError = (res && res.response && res.response.status >= 400) || !res.data || !res.data.data || !res.data.data.services.length;
      if (isError) {
        alert("No Services found for selected source and destination.");
        // clear the previous results
        dispatch({
          type: ROUTE_SERVICES,
          payload: { services: [], metaDetails: {} },
        })
        return;
      }
      let { services, ...metaDetails } = res.data.data;
      if(isReverseRouteClicked) {
        addReturnTripDeal(services);
      }
      else {
        addReturnTripDeal(services);
      }
      dispatch({
        type: ROUTE_SERVICES,
        payload: { services, metaDetails },
      })
    })
}

// export const getAllRoutesInfo = () => dispatch => {
//   getCall(GET_ALL_ROUTES_INFO)
//     .then(res => {
//       if(res && res.status === 200) {
//         dispatch({
//           type: ALL_ROUTES_INFO,
//           payload: res.data.data || {}
//         })
//         return;
//       }
//       let errorMsg = 'Error Occurred, please try later.';
//       if(res.response && res.response.data && res.response.data.message && res.response.data.message.display)
//         errorMsg = res.response.data.message.display;
//       alert(errorMsg);
//     })
// }

export const clearDealData = () => ({
  type: CLEAR_DEAL_DATA
})

export const fetchCities = (searchString, fieldType) => dispatch => {
  const url = BaseCoreURL + PHONETIC_CITY_SEARCH + searchString + '?is_phonetic=true';
  genericGetCall(url, {}, ['merchant'])
    .then(res => {
      if (res && res.status === 200) {
        dispatch({
          type: OPERATOR_ROUTES_LIST,
          payload: { data: res.data || [], fieldType },
        })
      } else {
        alert('Error, Please try again.');
      }
    })
}

export const refreshDeal = (payload, merchant) => dispatch => {
  postCall(REFRESH_DEAL, { ...payload, __essentialParams__: ['merchant'] })
    .then(res => {
      if (res && res.status === 200) {
        let msg = res.data.data.response || 'Refreshing Deals Inventory.'
        alert(msg);
      } else {
        const err = (res.response.data || {}).message || 'Error, Please try again.';
        alert(err);
      }
    })
}

const genericGetCall = (url, query = {}, essentialParams) => {
  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  };
  return axios
    .get(url, { headers, params: { ...query, ...getCommonParams(essentialParams) } })
    .then(response => response)
    .catch(error => {
      return error
    })
}


export const fetchDealList = () => dispatch => {
  getCall(`${FETCH_DEAL_LIST}`, {}, ['merchant'])
    .then(res => {
      if (res && res.status === 200) {
        dispatch({
          type: GET_DEAL_DATA,
          payload: { data: res.data || [] },
        })
      } else {

        alert('Error, Please try again.');
      }
    })
}

export const getServiceList = (servicesDataList) => dispatch => {
  dispatch({
    type: GET_SERVICE_LIST,
    payload: { data: servicesDataList }
  })
}

export const getSeat = (seat) => dispatch => {
  dispatch({
    type: GET_SEAT,
    payload: { data: seat }
  })
}

export const getBenchMarkingData = (mockDetails) => (dispatch) => {
  postCall(`${BENCCH_MARKING_DATA}`, { ...mockDetails, __essentialParams__: ['merchant'] }).then((res) => {
    if (res && res.status === 200) {
      dispatch({
        type: GET_BENCH_MARK,
        payload: { data: res.data || [] },
      });
    } else {
      alert("Error, Please try again.");
    }
    opdbGTM.competitorRouteSearch('od_deal_competitor_route_search', mockDetails.src, mockDetails.dest, res.data["bench-marking-data"].length);
  });
};

export const clearBenchMarkingData = () => (dispatch) => {
  dispatch({
    type: CLEAR_BENCH_MARK,
    payload: { data: [] }
  })
};

export const fetchTopRoutes = (mockDetails) => (dispatch) => {
  postCall(`${FETCH_TOP_ROUTES}`, { ...mockDetails, __essentialParams__: ['merchant'] }).then((res) => {
    if (res && res.status === 200) {
      dispatch({
        type: GET_TOP_ROUTES,
        payload: { data: res.data || [] },
      });
    }
  });
};

export const fetchDealsWiseAggregateData = (mockDetails) => (dispatch) => {
  postCall(`${FETCH_AGGREGATE_DATA}`, { ...mockDetails, __essentialParams__: ['merchant'] })
    .then((res) => {
      if (res && res.status === 200) {
        dispatch({
          type: GET_AGGREGATE_DATA,
          payload: { data: res.data || [] },
        });
      }
    });
};

export const fetchDateWiseAggregrate = (mockDetails) => (dispatch) => {
  postCall(`${FETCH_DATE_WISE_AGGREGATE}`, { ...mockDetails, __essentialParams__: ['merchant'] }).then(res => {
    if (res && res.status === 200) {
      dispatch({
        type: GET_DATE_WISE_AGGREGRATE_DATA,
        payload: { data: res.data || [] },
      });
    }
  })
};


export const fetchDealSummary = (mockDetails) => (dispatch) => {
  postCall(`${FETCH_DEALS_SUMMARY}`, { ...mockDetails, __essentialParams__: ['merchant'] }).then((res) => {
    dispatch({
      type: GET_DEALS_SUMMARY,
      payload: { data: res.data || [] },
    });
  });
};

export const setDynamicSeatData = (seatData) => dispatch => {
  dispatch({
    type: SET_DYNAMIC_SEAT_DATA,
    payload: { data: seatData }
  })
}
//Same bus For Different Route
export const addBtnClicked = (flag) => dispatch => {
  dispatch({
    type: ADD_BTN_CLICKED,
    payload: flag
  })
}
